/**
 * Copyright (c) 2019-2023 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { ChunkedArray } from '../../../mol-data/util';
import { Spheres } from './spheres';
// avoiding namespace lookup improved performance in Chrome (Aug 2020)
var caAdd3 = ChunkedArray.add3;
var caAdd = ChunkedArray.add;
export var SpheresBuilder;
(function (SpheresBuilder) {
    function create(initialCount, chunkSize, spheres) {
        if (initialCount === void 0) { initialCount = 2048; }
        if (chunkSize === void 0) { chunkSize = 1024; }
        var centers = ChunkedArray.create(Float32Array, 3, chunkSize, spheres ? spheres.centerBuffer.ref.value : initialCount);
        var groups = ChunkedArray.create(Float32Array, 1, chunkSize, spheres ? spheres.groupBuffer.ref.value : initialCount);
        return {
            add: function (x, y, z, group) {
                caAdd3(centers, x, y, z);
                caAdd(groups, group);
            },
            getSpheres: function () {
                var cb = ChunkedArray.compact(centers, true);
                var gb = ChunkedArray.compact(groups, true);
                return Spheres.create(cb, gb, centers.elementCount, spheres);
            }
        };
    }
    SpheresBuilder.create = create;
})(SpheresBuilder || (SpheresBuilder = {}));
